import { render, staticRenderFns } from "./tab-sistemas.vue?vue&type=template&id=acc30fb6&scoped=true&"
import script from "./tab-sistemas.vue?vue&type=script&lang=js&"
export * from "./tab-sistemas.vue?vue&type=script&lang=js&"
import style0 from "./tab-sistemas.vue?vue&type=style&index=0&id=acc30fb6&scoped=true&lang=css&"
import style1 from "./tab-sistemas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc30fb6",
  null
  
)

export default component.exports